const Router = [
    {
        path: "/user",
        redirect: "/user/profile",
        component: () => import("@/views/user/main.vue"),
        children: [
            {
                path: "profile",
                component: () => import("@/views/user/profile.vue"),
                name: "user_profile",
            },
            {
                path: "login",
                component: () => import("@/views/user/login.vue"),
                name: "login",
            },
        ],
    },
];

export default Router;
